// declares My work action types.

import MyworkConst from '../constants/this_week.constants';

export const MyworkFiltetActionItem = filterId => ({
  type: MyworkConst.MYWORK_FILTER_AI,
  filterId,
});

export const MyworkStatusActionItem = (actID, state, fromWs) => ({
  type: MyworkConst.MYWORK_STATUS_AI,
  actID,
  state,
  fromWs,
});

export const MyworkEffortActionItem = (actID, effort) => ({
  type: MyworkConst.MYWORK_EFFORT_AI,
  actID,
  effort,
});

export const MyworkStartDateActionItem = (actID, startDate) => ({
  type: MyworkConst.MYWORK_START_DATE_AI,
  actID,
  start_date: startDate,
});

export const MyworkEndDateActionItem = (actID, endDate, calView, monthWeek) => ({
  type: MyworkConst.MYWORK_END_DATE_AI,
  actID,
  due_date: endDate,
  calView,
  monthWeek,
});

export const MyworkReminderActionItem = (actID, dateTime) => ({
  type: MyworkConst.MYWORK_REMINDER_AI,
  actID,
  reminderData: dateTime,
});

export const MyworkRatingActionItem = (actID, rag) => ({
  type: MyworkConst.MYWORK_RATING_AI,
  actID,
  rag,
});

export const MyworkDelegateActionItem = actID => ({
  type: MyworkConst.MYWORK_DELEGATE_AI,
  actID,
});

export const MyworkPriorityActionItem = (actID, priority) => ({
  type: MyworkConst.MYWORK_PRIORITY_AI,
  actID,
  priority,
});

export const MyworkDeleteActionItem = actID => ({
  type: MyworkConst.MYWORK_DELETE_AI,
  actID,
});

export const MyworkAiAddNew = item => ({
  type: MyworkConst.MYWORK_AI_NEW,
  value: item,
});

export const MyworkAiUpdate = (id, key, items) => ({
  type: MyworkConst.MYWORK_AI_UPDATE,
  id,
  key,
  value: items,
});

export const MyworkDragDropDateAi = items => ({
  type: MyworkConst.MYWORK_AI_DRAG_DROP,
  value: items,
});

export const MyworkFiltetId = id => ({
  type: MyworkConst.MYWORK_FILTER_ID,
  id,
});

export const reloadMyWorkData = (data) => ({
  type: MyworkConst.MYWORK_RELOAD_DATA,
  data
});